<template>
  <div>
    <v-snackbar
      v-model="alert"
      :color="alertType"
      class="text-center"
      top>
      <div style="width:100%; text-align: center;">{{ message }}</div>
    </v-snackbar>
    
    <router-view></router-view>
  </div>
</template>
<script>
export default {
 computed:{
    message(){
        return this.$store.getters.getAlertMessage
    },
    alert(){
        return this.$store.getters.getAlert
    },
    alertType(){
        return this.$store.getters.getAlertType
    }
    
 },
 created(){
   if(localStorage.getItem('currentUrl')){
     this.$store.dispatch('tryAutoLogin')
   }
 },
 
};
</script>